import { render, staticRenderFns } from "./AccessLogs.vue?vue&type=template&id=1188f666"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/access-logs/AccessLogs.vue
// module id = null
// module chunks = 